import React, { Component } from 'react';
import {
  FormControl,
  IconButton,
  InputAdornment,
  MenuItem,
  Select,
  TextField,
} from '@material-ui/core';
import VpnKeyIcon from '@material-ui/icons/VpnKey';
import { Search } from '@material-ui/icons';
import SpinnerComponent from '../../../components/SpinnerComponent';
import ModalResetPsw from '../../../components/ModalResetPsw';
import EditRecordButton from '../components/EditRecordButton';
import NewRecordButton from '../components/NewRecordButton';
import UserActivationDialog from '../components/UserActivationDialog';
import SelezioneGruppo from '../components/SelezioneGruppo';
import TablePageToolbar from '../components/TablePageToolbar';
import BasicTable from '../../../components/BasicTable';
import { retrieveToken } from '../../../utils/storage';
import { setUserActivation } from '../../../utils/api/account_api';
import {
  handleInvalidToken as handleInvalidTokenFlow,
  SESSION_EXPIRED_HOME_MESSAGE,
} from '../../../utils/handleInvalidToken';
import {
  getConsulenti,
  getConsulentiFiltered,
  getTotaleConsulenti,
} from '../../../utils/api/consulenti_api';
import { getGruppi } from '../../../utils/api/gruppi_api';

import PropTypes from 'prop-types';
import { reportApiError, reportError } from '../../../utils/reportApiError';

const styles = {
  mainContainer: {
    textAlign: 'center',
    color: 'black',
  },
};

export default class ConsulentiTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      records: [],
      gruppoId: null,
      gruppi: [],
      loading: true,
      isUserActivationDialogOpen: false,
      isActivatingUser: false,
      selectedRecord: null,
      selectedEmail: '',
      openResetPswModal: false,
      totalPages: 1,
      loadedPage: 0,
      pageSize: 10,
      filter: {
        consulenteId: '',
        email: '',
        nome: '',
        cognome: '',
        telefono: '',
      },
    };
  }

  componentDidMount() {
    let id = this.props.gruppoId;

    this.setState({
      gruppoId: id,
    });

    if (this.props.consulenteId === null) {
      // user is admin
      this.fetchGruppi();
    } else {
      this.fetchRecords(id);
    }
  }

  handleInvalidToken = () =>
    handleInvalidTokenFlow({
      brandPath: this.props.theme.path,
      onNotify: () => reportError(SESSION_EXPIRED_HOME_MESSAGE),
    });

  fetchRecords = (gruppoId) => {
    const isAdmin = this.props.consulenteId === null;
    const isSuperConsulente = this.props.superconsulenteView;

    const fetchCountPromise =
      isAdmin || isSuperConsulente
        ? getTotaleConsulenti(gruppoId)
        : Promise.resolve(null); // creo una promise già risolta per mantenere una struttura uniforme

    this.setState({
      loading: true,
    });
    fetchCountPromise
      .then((countResponse) => {
        let consulenteId = this.props.consulenteId;
        if (isAdmin || isSuperConsulente) {
          // Admin and superconsulente can search records without filtering on consulenteId
          consulenteId = null;
        }
        return getConsulenti(
          consulenteId,
          gruppoId,
          0,
          this.state.pageSize,
          'id',
        ).then((result) => {
          this.setState({
            loadedPage: 0,
            records: result,
            totalPages: countResponse
              ? Math.ceil(countResponse / this.state.pageSize)
              : this.state.totalPages,
          });
        });
      })
      .catch((error) => {
        reportApiError(error);
      })
      .finally(() =>
        this.setState({
          loading: false,
        }),
      );
  };

  // An admin searches the group picked in the toolbar, -1 for all of them;
  // everyone else searches their own group.
  selectedGruppoId = () =>
    this.props.consulenteId === null
      ? this.state.gruppoId
      : this.props.gruppoId;

  fetchConsulentiForResearch = (loadedPage) => {
    const { filter, pageSize } = this.state;
    const gruppoId = this.selectedGruppoId();
    const isConsulente =
      this.props.consulenteId !== null && !this.props.superconsulenteView;

    if (!isConsulente) {
      getTotaleConsulenti(
        gruppoId,
        filter.consulenteId,
        filter.email,
        filter.nome,
        filter.cognome,
        filter.telefono,
      )
        .then((countResponse) => {
          return getConsulentiFiltered(
            filter.consulenteId,
            gruppoId,
            loadedPage,
            pageSize,
            'id',
            filter.email,
            filter.nome,
            filter.cognome,
            filter.telefono,
          ).then((response) =>
            this.setState({
              loadedPage: 0,
              records: response,
              totalPages:
                countResponse !== 0 ? Math.ceil(countResponse / pageSize) : 1,
            }),
          );
        })
        .catch((error) => {
          reportApiError(error);
        });
    }
  };

  fetchConsulentiForPageChange = (loadedPage) => {
    const { filter, pageSize } = this.state;
    const isConsulente =
      this.props.consulenteId !== null && !this.props.superconsulenteView;

    if (isConsulente) {
      return;
    }

    getConsulentiFiltered(
      filter.consulenteId,
      this.selectedGruppoId(),
      loadedPage,
      pageSize,
      'id',
      filter.email,
      filter.nome,
      filter.cognome,
      filter.telefono,
    )
      .then((response) =>
        this.setState({
          records: response,
        }),
      )
      .catch((error) => {
        reportApiError(error);
      });
  };

  fetchGruppi = () => {
    getGruppi(null, null, 0, 1000, 'nome')
      .then((result) => {
        const gruppi = [{ id: -1, nome: 'Tutti i gruppi' }, ...result];
        const gruppoId = this.state.gruppoId ?? -1;
        this.setState({
          gruppi,
          gruppoId,
        });
        this.fetchRecords(gruppoId);
      })
      .catch((error) => {
        reportApiError(error);
      });
  };

  updateUserStatus = () => {
    this.setState({
      loading: true,
    });
    let token = retrieveToken();
    if (token === null) {
      // If token was deleted, redirect to home page:
      this.handleInvalidToken();
    } else {
      setUserActivation(
        this.state.selectedRecord.userId,
        this.state.isActivatingUser,
      )
        .then(() => {
          this.setState({
            loading: false,
          });
          this.fetchRecords(this.state.gruppoId);
        })
        .catch((error) => {
          //Reset activated flag to origina value:
          this.resetUserActivatedFlag();
          this.setState({
            loading: false,
          });
          reportApiError(error);
        });
    }
  };

  onStatusChanged = (record, event) => {
    let flag = event.target.value;
    const elementIndex = this.state.records.findIndex(
      (element) => element.id === record.id,
    );
    let newArray = [...this.state.records];
    newArray[elementIndex] = {
      ...newArray[elementIndex],
      activated: !newArray[elementIndex].activated,
    };
    this.setState({
      records: newArray,
      selectedRecord: newArray[elementIndex],
      isUserActivationDialogOpen: true,
      isActivatingUser: flag,
    });
  };

  onStatusChangeConfirmed = (hasConfirmed) => {
    this.closeUserActivationDialog();
    // Proceed with POST only if user confirmed the operation:
    if (hasConfirmed) {
      this.updateUserStatus();
    } else {
      //otherwise reset activated flag to the original value:
      this.resetUserActivatedFlag();
    }
  };

  resetUserActivatedFlag = () => {
    const elementIndex = this.state.records.findIndex(
      (element) => element.id === this.state.selectedRecord.id,
    );
    let newArray = [...this.state.records];
    newArray[elementIndex] = {
      ...newArray[elementIndex],
      activated: !newArray[elementIndex].activated,
    };
    this.setState({
      records: newArray,
    });
  };

  closeUserActivationDialog = () => {
    this.setState({
      isUserActivationDialogOpen: false,
    });
  };

  onResetPswButtonClicked = (email) => {
    this.setState({
      selectedEmail: email,
      openResetPswModal: true,
    });
  };

  // A reset changes nothing the table shows, so a completed one and a
  // cancelled one both just close the dialog.
  onResetPswModalClosed = () => {
    this.setState({
      openResetPswModal: false,
    });
  };

  handleSelectedGruppo = (gruppoId) => {
    this.setState(
      {
        gruppoId,
        filter: {
          consulenteId: '',
          email: '',
          nome: '',
          cognome: '',
          telefono: '',
        },
      },
      () => {
        this.fetchRecords(gruppoId);
      },
    );
  };

  generateFilterColumn = ({ id, placeholder, filterValue, onChange }) => {
    return {
      Header: placeholder,
      id: id,
      accessor: (d) => d[id],
      filterable: true,
      minWidth: 120,
      Filter: (
        <TextField
          variant="outlined"
          fullWidth
          value={filterValue}
          onChange={(e) => {
            const value = e.target.value;
            onChange(value);
          }}
          inputProps={{ 'aria-label': `Filtra per ${placeholder}` }}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton
                  size="small"
                  aria-label={`Cerca per ${placeholder}`}
                  onClick={() => this.fetchConsulentiForResearch(0)}
                >
                  <Search />
                </IconButton>
              </InputAdornment>
            ),
          }}
        />
      ),
    };
  };

  getCommonColumns = () => {
    return [
      {
        Header: 'Numero',
        id: 'numero',
        accessor: (row) => row,
        width: 120,
        filterable: false,
        // 0-based, as every other table in the panel numbers its rows. The
        // concatenation reads correctly only while pageSize stays 10 and the
        // index stays one digit: at another pageSize this needs arithmetic.
        Cell: (props) =>
          this.state.loadedPage === 0
            ? '' + props.index
            : this.state.loadedPage + '' + props.index,
      },
      this.generateFilterColumn({
        id: 'id',
        placeholder: 'ID consulente',
        filterValue: this.state.filter.consulenteId,
        onChange: (value) => {
          if (/^\d*$/.test(value)) {
            this.setState((prevState) => ({
              filter: {
                ...prevState.filter,
                consulenteId: value,
              },
            }));
          }
        },
      }),
      {
        Header: 'Superconsulente',
        id: 'superconsulente',
        accessor: (d) => d.superconsulente,
        width: 140,
        filterable: false,
        Cell: (props) => (props.value ? 'Sì' : 'No'),
      },
      this.generateFilterColumn({
        id: 'email',
        placeholder: 'Email',
        filterValue: this.state.filter.email,
        onChange: (value) =>
          this.setState((prevState) => ({
            filter: {
              ...prevState.filter,
              email: value,
            },
          })),
      }),
      this.generateFilterColumn({
        id: 'nome',
        placeholder: 'Nome',
        filterValue: this.state.filter.nome,
        onChange: (value) =>
          this.setState((prevState) => ({
            filter: {
              ...prevState.filter,
              nome: value,
            },
          })),
      }),
      this.generateFilterColumn({
        id: 'cognome',
        placeholder: 'Cognome',
        filterValue: this.state.filter.cognome,
        onChange: (value) =>
          this.setState((prevState) => ({
            filter: {
              ...prevState.filter,
              cognome: value,
            },
          })),
      }),
      this.generateFilterColumn({
        id: 'telefono',
        placeholder: 'Telefono',
        filterValue: this.state.filter.telefono,
        onChange: (value) =>
          this.setState((prevState) => ({
            filter: {
              ...prevState.filter,
              telefono: value,
            },
          })),
      }),
      {
        Header: 'Stato',
        id: 'activated',
        accessor: (row) => row,
        width: 120,
        filterable: false,
        Cell: (props) =>
          this.props.consulenteId !== null &&
          !this.props.superconsulenteView ? (
            <div>{props.value.activated ? 'ATTIVO' : 'NON ATTIVO'}</div>
          ) : (
            <FormControl>
              <Select
                value={props.value.activated}
                name="activated"
                // MUI names the picker after its own id, which would be the
                // same on every row; the label carries the consultant and the
                // value instead.
                SelectDisplayProps={{
                  id: `stato-consulente-${props.value.id}`,
                  'aria-labelledby': undefined,
                  'aria-label': `Stato di ${props.value.email}: ${
                    props.value.activated ? 'Attivo' : 'Non attivo'
                  }`,
                }}
                onChange={(event) => {
                  this.onStatusChanged(props.value, event);
                }}
              >
                <MenuItem value={true}>Attivo</MenuItem>
                <MenuItem value={false}>Non attivo</MenuItem>
              </Select>
            </FormControl>
          ),
      },
      {
        id: 'editBtn',
        Header: 'Modifica',
        accessor: (row) => row,
        width: 80,
        filterable: false,
        Cell: (props) => (
          <EditRecordButton
            recordId={props.value.id}
            disabled={false}
            ariaLabel={`Modifica ${props.value.email}`}
          />
        ),
      },
    ];
  };

  getResetPasswordColumn = () => ({
    id: 'resetPswBtn',
    Header: 'Reset password',
    accessor: (row) => row,
    width: 130,
    filterable: false,
    Cell: (props) => {
      const disabledReset =
        !!props.value.oauthEnabled || props.value.passwordEnabled === false;
      return (
        <IconButton
          style={{
            color: disabledReset
              ? this.props.theme.palette.disabled.main
              : this.props.theme.palette.primary.main,
          }}
          aria-label="reset psw"
          size="small"
          disabled={disabledReset}
          onClick={() => {
            this.onResetPswButtonClicked(props.value.email);
          }}
        >
          <VpnKeyIcon />
        </IconButton>
      );
    },
  });

  getColumns = () => {
    let columns = this.getCommonColumns();
    const isAdmin =
      !this.props.superconsulenteView && this.props.consulenteId === null;
    const isSuperConsulente = this.props.superconsulenteView;

    if (isAdmin) {
      columns.splice(2, 0, {
        id: 'gruppoId',
        Header: 'ID gruppo',
        accessor: (row) => row.gruppoId,
        filterable: false,
      });
    }
    if (isAdmin || isSuperConsulente) {
      columns.push(this.getResetPasswordColumn());
    }
    return columns;
  };

  onPageChange = (pageIndex) => {
    this.setState({ loadedPage: pageIndex }, () =>
      this.fetchConsulentiForPageChange(this.state.loadedPage),
    );
  };

  render() {
    const columns = this.getColumns();
    const isAdmin =
      this.props.consulenteId === null && !this.props.superconsulenteView;
    const isConsulente =
      this.props.consulenteId !== null && !this.props.superconsulenteView;

    return (
      <div
        style={{ paddingTop: isAdmin ? '10px' : '30px', minHeight: '400px' }}
      >
        {this.state.loading ? (
          <SpinnerComponent size={24} />
        ) : (
          <div style={styles.mainContainer}>
            {isAdmin && (
              <TablePageToolbar
                filters={
                  <SelezioneGruppo
                    layout="toolbar"
                    gruppoId={this.state.gruppoId}
                    gruppi={this.state.gruppi}
                    disabled={false}
                    description=""
                    onGruppoSelected={this.handleSelectedGruppo}
                  />
                }
              />
            )}
            {!isConsulente && (
              <div
                style={{
                  paddingTop: '10px',
                  paddingBottom: '10px',
                  textAlign: 'right',
                }}
              >
                <NewRecordButton disabled={false} />
              </div>
            )}
            <BasicTable
              data={this.state.records}
              columns={columns}
              filterable={false}
              resizable={true}
              sortable={false}
              defaultPageSize={this.state.pageSize}
              page={this.state.loadedPage}
              pages={this.state.totalPages}
              onPageChange={this.onPageChange}
            />
          </div>
        )}
        <UserActivationDialog
          isOpen={this.state.isUserActivationDialogOpen}
          isActivatingUser={this.state.isActivatingUser}
          onButtonClicked={this.onStatusChangeConfirmed}
        />
        {this.state.openResetPswModal && (
          <ModalResetPsw
            theme={this.props.theme}
            email={this.state.selectedEmail}
            open={this.state.openResetPswModal}
            onClose={this.onResetPswModalClosed}
          />
        )}
      </div>
    );
  }
}

ConsulentiTable.propTypes = {
  consulenteId: PropTypes.number,
  gruppoId: PropTypes.number,
  superconsulenteView: PropTypes.bool.isRequired,
  theme: PropTypes.object.isRequired,
};
